import { type StringSchema, bool, object, string } from 'yup';

import { OTHER_BUSINESS_TYPE } from '@/constants/businessTypes';
import { VALIDATION_MESSAGES } from '@/constants/validation';
import { isValidPhoneNumber } from 'libphonenumber-js';


export type CompanyDetailsFormData = {
	name: string;
	address: string;
	workEmail: string;
	companySize: string;
	mobileNumber?: string;
	natureOfBusiness: string;
	natureOfBusinessOther?: string;
	agree: boolean;
};

export const schema = object({
	name: string().trim().required(VALIDATION_MESSAGES.required),
	address: string().trim().required(VALIDATION_MESSAGES.required),
	workEmail: string()
		.trim()
		.email(VALIDATION_MESSAGES.email)
		.required(VALIDATION_MESSAGES.required),
	companySize: string().trim().required(VALIDATION_MESSAGES.required),
	mobileNumber: string().trim().optional()
		.test('is-valid-phone', 'Please enter a valid phone number', function (value) {
			if (!value) return true; // Let required validation handle empty values

			try {
				const res = isValidPhoneNumber(value);
				return res;
			} catch (error) {
				return false;
			}
		}),
	natureOfBusiness: string().trim().required(VALIDATION_MESSAGES.required),
	natureOfBusinessOther: string()
		.trim()
		.when('natureOfBusiness', {
			is: (value: string) => value === OTHER_BUSINESS_TYPE.value,
			// biome-ignore lint/suspicious/noThenProperty: `then` is part of the schema
			then: (schema: StringSchema) =>
				schema.required(VALIDATION_MESSAGES.required),
		}),
	agree: bool()
		.required(VALIDATION_MESSAGES.required)
		.oneOf([true], VALIDATION_MESSAGES.requiredShort),
});

export const defaultValues = {
	name: '',
	address: '',
	workEmail: '',
	companySize: '',
	mobileNumber: '',
	natureOfBusiness: '',
	natureOfBusinessOther: '',
	agree: false,
};
